module.exports = __webpack_public_path__ + "img/01.c9b885aa.png";